import { Stack, Typography } from '@mui/material';

import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import RowContentTwo from './components/RowContent';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
  dietList: string[];
  setDietList: (dietList: string[]) => void;
}

const checks = [
  {
    label: 'NPO (Không ăn gì qua đường miệng)',
    key: 'dinner.default_diet.checked1',
  },
  {
    label: 'SOW (Chỉ uống nước)',
    key: 'dinner.default_diet.checked2',
  },
  {
    label: 'LD (Chế độ ăn lỏng)',
    key: 'dinner.default_diet.checked3',
  },
  {
    label: 'SD (Chế độ ăn mềm)',
    key: 'dinner.default_diet.checked4',
  },
  {
    label: 'RD (Chế độ ăn thường)',
    key: 'dinner.default_diet.checked5',
  },
  {
    label: 'TD (Chế độ ăn dung nạp)',
    key: 'dinner.default_diet.checked6',
  },
  {
    label: 'NG (Ống thông mũi-dạ dày)',
    key: 'dinner.default_diet.checked7',
  },
  {
    label: 'TPN (dinh dưỡng qua đường tĩnh mạch)',
    key: 'dinner.default_diet.checked8',
  },
];

const checks2 = [
  {
    label: 'Tiểu đường',
    key: 'dinner.treatment.checked1',
  },
  {
    label: 'Béo phì',
    key: 'dinner.treatment.checked2',
  },
  {
    label: 'Tim mạch',
    key: 'dinner.treatment.checked3',
  },
  {
    label: 'Bệnh tiêu hoá',
    key: 'dinner.treatment.checked4',
  },
  {
    label: 'Loãng xương',
    key: 'dinner.treatment.checked5',
  },
  {
    label: 'Constipation',
    key: 'dinner.treatment.checked6',
  },
  {
    label: 'Thiếu máu',
    key: 'dinner.treatment.checked7',
  },
  {
    label: 'Sỏi thận',
    key: 'dinner.treatment.checked8',
  },
  {
    label: 'Gout',
    key: 'dinner.treatment.checked9',
  },
  {
    label: 'Radiation Therapy',
    key: 'dinner.treatment.checked10',
  },
  {
    label: 'Ung thư dạ dày',
    key: 'dinner.treatment.checked11',
  },
  {
    label: 'Ung thư trực tràng',
    key: 'dinner.treatment.checked12',
  },
  {
    label: 'Ung thư gan',
    key: 'dinner.treatment.checked13',
  },
  {
    label: 'Ung thư ngực',
    key: 'dinner.treatment.checked14',
  },
  {
    label: 'Ung thư phổi',
    key: 'dinner.treatment.checked15',
  },
  {
    label: 'Ung thư thực quản',
    key: 'dinner.treatment.checked16',
  },
  {
    label: 'Ung thư tuyến tụy',
    key: 'dinner.treatment.checked17',
  },
  {
    label: 'Ung thư tuyến tiền liệt',
    key: 'dinner.treatment.checked18',
  },
  {
    label: 'Ung thư tuyến giáp',
    key: 'dinner.treatment.checked19',
  },
  {
    label: 'Huyết học ác tính',
    key: 'dinner.treatment.checked20',
  },
  {
    label: 'Ung thư đầu và ung thư cổ',
    key: 'dinner.treatment.checked21',
  },
  {
    label: 'Trào ngược dạ dày - thực quản',
    key: 'dinner.treatment.checked22',
  },
  {
    label: 'Bệnh thận',
    key: 'dinner.treatment.checked23',
  },
  {
    label: 'Suy thận',
    key: 'dinner.treatment.checked24',
  },
];

const DietSelection3 = (props: Props) => {
  const { disabled, register, getValues, setValue, dietList, setDietList } =
    props;

  const 적용급식1 = checks
    .filter((item, i) => getValues(item.key))
    .map(v => v.label);

  const 적용급식2 = checks2
    .filter((item, i) => getValues(item.key))
    .map(v => v.label);

  const 적용급식필터링1 = 적용급식1.join(', ');
  const 적용급식필터링2 = 적용급식2.join(', ');

  const total = 적용급식필터링1 + ' ' + 적용급식필터링2;

  return (
    <>
      <SectionTitle title="Bữa tối" />

      <RowContainer xs={12}>
        <RowContent title="Calorie(Kcal)" titleRatio={1.3} childrenRatio={10.7}>
          <Stack direction="row" spacing={1}>
            <Form.MuiTextField
              required={false}
              fullWidth
              placeholder="Nhập nếu cần thiết"
              InputProps={{ ...Form.adornment('', 'Kcal') }}
              {...register('dinner.calorie')}
            />
          </Stack>
        </RowContent>
        <RowContent title="Bữa tối" titleRatio={10.5} childrenRatio={1.5}>
          <Stack direction="row" spacing={1}></Stack>
        </RowContent>
        <RowContentTwo title="" titleRatio={0} childrenRatio={12}>
          <Form.MuiTextField
            fullWidth
            InputProps={{ readOnly: true }}
            placeholder={total.length > 0 ? total : 'Dinner List'}
            multiline
            minRows={3}
          />
        </RowContentTwo>
      </RowContainer>
      <Box sx={{ width: '95%', margin: '30px auto 0px auto' }}>
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          Chế độ ăn cơ bản
        </Typography>

        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>

        <br />
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          Chế độ ăn điều trị
        </Typography>
        <Grid container xs={12}>
          {checks2.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default DietSelection3;
